"use client";

function ServicesPage(props: { yScroll?: number }) {
  return (
    <>
      <div className="pt-24 pb-12 px-2 md:px-[10%] flex items-center justify-center mb-12">
        <div className="container flex flex-col justify-center gap-2 relative">
          <h1 className="text-2xl text-black font-medium mb-2">SERVICES</h1>
          <div className="flex flex-col md:flex-row gap-4">
            <div className="md:pr-2">
              We collaborate with bold MINDers to transform the world’s most
              complex visions into reality, blending cutting-edge architecture,
              immersive virtual reality, and innovative IT solutions to create
              spaces and systems that endure.​
            </div>
            <div className="md:pl-2">
              Our teams redefine possibility—designing iconic skyline-defining
              structures, pioneering the first fully virtual urban planning
              platform, optimizing asset management with next-gen technology,
              and crafting digital experiences that bridge the physical and
              virtual worlds. We don’t just shape environments; we architect
              legacies that inspire generations.​
            </div>
          </div>
        </div>
      </div>
      <div className="bg-primary py-8 md:py-10 px-2 md:px-[10%] grid md:grid-cols-2 gap-4">
        <div>
          <div className="bg-white px-4 py-1 text-primary font-bold rounded-full w-fit">
            Architecture and Design
          </div>
          <div className="px-4 text-white [&>*]:mt-1">
            <div>Architecture</div>
            <div>Asset Advisory</div>
            <div>Interior Architecture</div>
            <div>Landscape Architecture</div>
            <div>Planning</div>
            <div>Urban Design</div>
          </div>
        </div>
        <div>
          <div className="bg-white px-4 py-1 text-primary font-bold rounded-full w-fit">
            IT & Digitalisation
          </div>
          <div className="px-4 text-white [&>*]:mt-1">
            <div>Cloud Solutions</div>
            <div>Cybersecurity Architecture</div>
            <div>Data Integration</div>
            <div>Smart Systems Development</div>
            <div>Digital Transformation Consulting</div>
            <div>Automation Engineering</div>
          </div>
        </div>
        <div>
          <div className="bg-white px-4 py-1 text-primary font-bold rounded-full w-fit">
            Asset Management
          </div>
          <div className="px-4 text-white [&>*]:mt-1">
            <div>Portfolio Optimization</div>
            <div>Lifecycle Planning</div>
            <div>Risk Assessment</div>
            <div>Performance Analytics</div>
            <div>Sustainability Integration</div>
            <div>Strategic Valuation</div>
          </div>
        </div>
        <div>
          <div className="bg-white px-4 py-1 text-primary font-bold rounded-full w-fit">
            Virtual Reality
          </div>
          <div className="px-4 text-white [&>*]:mt-1">
            <div>Immersive Design Visualization</div>
            <div>Virtual Space Prototyping</div>
            <div>Interactive User Experience</div>
            <div>Simulation and Training Environments</div>
            <div>Augmented Reality Integration</div>
            <div>Digital Twin Creation</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ServicesPage;
